import { createAction } from 'redux-actions';

export const AuthActionTypes = {
  AUTH_ERROR: '[AUTH] - AUTH ERROR',
  LOGIN_SUCCESS: '[AUTH] - LOGIN SUCCESS'
};

export const AuthActions = {
  authError: createAction(AuthActionTypes.AUTH_ERROR),
  loginSuccess: createAction(AuthActionTypes.LOGIN_SUCCESS)
};
